export const membershipBenefitsIntro =
  "Membership in the Bombay Catholic Sabha (BCS) is much more than holding an identity card. It is an opportunity to participate actively in the social, civic, and public life of the Catholic community.";

export const membershipBenefits = [
  {
    title: "Representation of Catholic Interests",
    body:
      "BCS is the officially recognized lay organization of the Archdiocese of Bombay and represents the concerns of Catholics and Christians before government authorities and public bodies on issues affecting the community.",
  },
  {
    title: "Protection of Community Rights",
    body:
      "The Sabha has historically taken up matters concerning human rights, social justice, minority rights, protection of heritage crosses, educational issues, and other matters affecting the Christian community.",
  },
  {
    title: "Civic and Political Awareness",
    body:
      "Members are encouraged to become informed citizens through voter registration drives, civic engagement programs, interaction with elected representatives, and awareness of government policies and schemes.",
  },
  {
    title: "Access to Community Programs",
    body: "Parish units organize:",
    bullets: [
      "Medical camps",
      "Academic excellence awards",
      "Career guidance programs",
      "Help desks for parishioners",
      "Interfaith and community-building initiatives",
      "Social and cultural activities",
    ],
  },
  {
    title: "Youth Development and Career Support",
    body:
      "BCS conducts youth training programs, career guidance, and initiatives aimed at helping young Catholics prepare for civil services and government employment opportunities.",
  },
  {
    title: "Networking and Fellowship",
    body:
      "Membership provides opportunities to interact with Catholics across parishes, deaneries, and districts, fostering unity, leadership, and community service.",
  },
  {
    title: "Social Service Opportunities",
    body:
      "Members can participate in charitable, environmental, educational, and social justice initiatives that benefit both the Catholic community and society at large.",
  },
  {
    title: "Environmental and Social Action",
    body:
      "The Sabha actively promotes environmental protection, waste management, renewable energy awareness, and other initiatives inspired by Catholic social teaching.",
  },
  {
    title: "Being Part of a Larger Movement",
    body:
      "With more than 67,689+ members across the Archdiocese, BCS is among the largest Catholic lay organizations in India and is affiliated with the All India Catholic Union, giving members a voice at local, regional, and national levels.",
  },
];

export const membershipBenefitsSummary =
  "A Bombay Catholic Sabha member is not merely a spectator but an active participant in building a just society, protecting community rights, serving the Church, and strengthening the Catholic voice in civic and public life.";

export const membershipBenefitsMotto =
  "To Create a Just Society through Involvement in Socio, Civic and Political Affairs.";
